var _defs, _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_a4584948f52c3fa1d26d795fc4ff4e1e7533047eacfa0d2228f4caa61ce604df",
    x1: 111.34,
    y1: 90.56,
    x2: 148.99,
    y2: 90.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M99.4 67.06h12.86M99.4 75.77h7.79M99.4 83.91h5.84M70.31 67.06h12.85M70.31 75.77h12.85M70.31 83.91h12.85M99.4 92.38h6.98M99.4 100.52h11.21M70.31 92.38h12.85M70.31 100.52h12.85M91.93 57.58v51.49M66.46 43.96h50.93v12.9H66.46zM52.39 44.17h-17.7V27.5a8.86 8.86 0 0117.7 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M132.11 111.03v24.46H52.35l.04-91.32M43.54 18.83h79.72a8.74 8.74 0 018.85 8.55v32.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 130.99,
    cy: 85.29,
    r: 25.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M150.459 111.073l6.314-6.314 21.66 21.658-6.315 6.315zM148.89 103.48l4.39 3.94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M147.74 93a18.43 18.43 0 01-33.43-15.53",
    stroke: "url(#SVGID_0_a4584948f52c3fa1d26d795fc4ff4e1e7533047eacfa0d2228f4caa61ce604df)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountAnalysis);
export default __webpack_public_path__ + "static/media/accountAnalysis.5eb5d8f6ced2f18b8fd45cbe36c1c667.svg";
export { ForwardRef as ReactComponent };